import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const SEO = ({
  title = 'Ekatva 2026 | SMVDU Techfest',
  description = 'Ekatva 2026 - The Annual Techfest of Shri Mata Vaishno Devi University. Explore competitions, events, and innovations.',
  name = 'Ekatva',
  type = 'website',
  url = 'https://ekatva-fest.smvdu.ac.in/',
  image = 'https://ekatva-fest.smvdu.ac.in/logo_ekatva.webp',
  imageAlt = 'Ekatva 2026 Techfest',
  twitterHandle = '@ekatva',
  keywords = 'Ekatva, Techfest, SMVDU, Competitions, Events',
  author = 'Ekatva Team',
  canonicalUrl = 'https://ekatva-fest.smvdu.ac.in/',
  structuredData = null,
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:site_name" content={name} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {twitterHandle && <meta name="twitter:creator" content={twitterHandle} />}
      
      {/* Additional Meta Tags */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  twitterHandle: PropTypes.string,
  keywords: PropTypes.string,
  author: PropTypes.string,
  canonicalUrl: PropTypes.string,
  structuredData: PropTypes.object,
};

export default SEO;
